import { render } from "./MobileApprove.vue?vue&type=template&id=2aefee98&scoped=true"
import script from "./MobileApprove.vue?vue&type=script&lang=js"
export * from "./MobileApprove.vue?vue&type=script&lang=js"

import "./MobileApprove.vue?vue&type=style&index=0&id=2aefee98&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aefee98"]])

export default __exports__